import env from 'env';

export type ICompanySearchResult = {
  name: string;
  domain: string;
  icon: string;
  brandId: string;
  claimed: boolean;
};

export const searchCompanies = async (name: string): Promise<ICompanySearchResult[]> => {
  const trimmedName = name.trim();
  if (!trimmedName) return [];

  try {
    const response = await fetch(
      `https://api.brandfetch.io/v2/search/${encodeURIComponent(trimmedName)}?c=${env.BRANDFETCH_CLIENT_ID}`,
    );

    if (!response.ok) {
      console.error(`searchCompanies: request failed with status ${response.status}`);
      return [];
    }

    return await response.json();
  } catch (error) {
    console.error('searchCompanies: request failed', error);
    return [];
  }
};
